<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I’d like to extend my rental term</h1>
			<p>
				Rental terms are not able to be extended.
				The end date is set to the end date of most terms.
				If your term ends before then, you will need to buyout the item.
			</p>

			<p>
				<a class="help-link" :href="`/account/rentaldet.php?olid=${order_line_id}`">Rental Control Panel</a>
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';

	export default {
		name: "ExtendRental",

		components: {
			BaseNavLinks,
		},

		data() {
			return {
				order_line_id: 0,
			}
		},

		mounted() {
			this.order_line_id = parseInt(this.$route.params.id);
		},
	}
</script>

<style scoped>

</style>